import React from 'react'
import { Link } from 'react-router-dom'
import './Header.css'

const Header = ({
  headerTitle,
  handleSave,
  showPreview,
  parentRoute,
  disableSave,
}) => {
  return (
    <div className="NewHeader">
      <div className="row">
        <div className="col s4">
          <h4>{headerTitle}</h4>
        </div>
        <div className="col s8 NewButtons right-align">
          <button
            className={
              'btn btn-default blue darken-1 ' + (disableSave ? 'disabled' : '')
            }
            onClick={handleSave}
          >
            Save
          </button>
          <Link to={parentRoute}>
            <button className="btn btn-default red darken-1">Cancel</button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Header
